<template>
  <GallerySettings />
</template>

<script>
import GallerySettings from '@/components/admin/GallerySettings.vue'

export default {
  name: 'AdministrationGallery',
  components: { GallerySettings }
}
</script>

<style scoped>

</style>
